import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StoreContext } from 'redux-react-hook';
import eruda from 'eruda';
import './index.scss';
import App from './App';
import { copyRightStore } from '../../store/index';
import * as serviceWorker from '../../serviceWorker';
const store = copyRightStore();
window.__copryrightstore = store;
ReactDOM.render(
	<StoreContext.Provider value={store}>
		<App />
	</StoreContext.Provider>,
	document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
let env = process.env.REACT_APP_ENV;
if (env !== 'dev') {
	serviceWorker.register({
		scopeName: '/vpmobile/static/copyright'
	});
//	eruda.init();
} else {
	serviceWorker.unregister();
}
